import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { PaypointService } from '../../../services/paypoint.service';
import { PaypointResponse } from '../../../models/paypoint-response.interface';

interface PaypointOption {
  value: string;
  viewValue: string;
}

@Component({
  selector: 'kt-bridgepay-add-routing-rule',
  templateUrl: './add-routing-rule.component.html',
  styleUrls: ['./add-routing-rule.component.scss'],
})
export class AddRoutingRuleComponent implements OnInit {
  addRuleForm: FormGroup;
  isSubmitting = false;

  @Input() organization: string;
  @Input() officeId: string;

  @Input() paypoints: PaypointResponse[] = [];

  @Output() addRule = new EventEmitter<void>();

  // Sample options – in real app these come from backend or context.
  paymentMethodOptions = [
    { value: '', viewValue: 'Select payment method' },
    { value: 'card', viewValue: 'Card Payments' },
    { value: 'ach', viewValue: 'ACH Payments' },
    { value: 'all', viewValue: 'All Payment Types (Fallback)' },
  ];

  paypointOptions: PaypointOption[] = [];

  // A sample validation warning (this could be dynamic based on your business logic)
  ruleValidationMessage = 'This rule may overlap with existing rules for Card Payments';

  constructor(
    private fb: FormBuilder,
    private paypointService: PaypointService,
    private snackBar: MatSnackBar,
  ) {}

  ngOnInit(): void {
    this.addRuleForm = this.fb.group({
      paymentMethod: ['', Validators.required],
      targetPaypoint: ['', Validators.required],
      minAmount: [null, Validators.min(0)],
      maxAmount: [null],
      priority: [null, Validators.required],
    });
    this.paypointOptions = this.paypoints.map((p) => ({
      value: p.paypoint_code,
      viewValue: `${p.provider} (${this.formatPaypointCode(p.paypoint_code)})`,
    }));

    // Optionally, you can add cross-field validators here (e.g. ensuring maxAmount > minAmount)
  }
  formatPaypointCode(value: string): string {
    if (!value) {
      return '';
    }
    // Remove "payment-" prefix if present
    let code = value.replace(/^paypoint-/, '');
    // Remove all dashes
    code = code.replace(/-/g, '');
    // Get the first 5 characters and convert to uppercase
    const shortCode = code.substring(0, 5).toUpperCase();
    return `#PP-${shortCode}`;
  }

  onSave(): void {
    if (this.addRuleForm.invalid) {
      this.snackBar.open('Please fill all required fields correctly.', 'Close', { duration: 3000 });
      return;
    }
    this.isSubmitting = true;
    const ruleData = this.addRuleForm.value;
    // Optionally transform ruleData as needed.
    this.paypointService.addRoutingRule(this.organization, this.officeId, ruleData).subscribe(
      () => {
        this.snackBar.open('Routing rule added successfully!', 'Close', { duration: 3000 });
        this.isSubmitting = false;
        this.addRuleForm.reset();
        this.addRule.emit();
      },
      (error) => {
        this.snackBar.open('Error adding rule: ' + error.message, 'Close', { duration: 5000 });
        this.isSubmitting = false;
      },
    );
  }

  onCancel(): void {
    this.addRuleForm.reset();
  }
}
